import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }

  zipCodeValidator(control) {
    const max = 999999; // Maximum allowed length for the zip code
    if (control.value && control.value > max) {
      return {zipCodeTooBig: true};
    }
    return null;
  }
}
